import styled from '@emotion/styled';

export const SadaKScheduleEvent = styled.div``;
